import { auditReports } from '@mi-front/api-clients';

/**
 * Hook to load blueprint and definition data for the report definition editor by definition ID.
 * First loads the definition by ID, then fetches the blueprint using the definition's reportType and blueprintVersion.
 */
export function useReportDefinitionQuery(id: string) {
  const definitionQuery = auditReports.useGetReportDefinitionById(id, {
    query: {
      enabled: !!id,
    },
  });

  const definition = definitionQuery.data;

  const blueprintQuery = auditReports.useGetBlueprintMetadataMetadata(
    definition?.reportType || '',
    definition?.blueprintVersion ? { blueprintVersion: definition.blueprintVersion } : undefined,
    {
      query: {
        enabled: !!definition,
      },
    },
  );

  return {
    blueprintQuery,
    definitionQuery,
  };
}
